module.exports = __webpack_public_path__ + "amcharts/images/lensWhite.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/lensWhite.png
// module id = 272
// module chunks = 0